<template>
	<div>

		<h3 class="mb-3">Referrer Stage Change Notifications</h3>

		<el-form v-loading="fetchingNotifications" ref="notificationForm" :model="notificationForm">

			<el-row v-for="(notification, key) in notificationForm.notifications" :key="key" :gutter="10">
				<el-col :span="10">
					<el-form-item
                        :prop="`notifications.${key}.stage`"
                        :rules="{required: true, message: 'Required', trigger: 'change'}"
                        label="Application Status">
						<el-select :disabled="savingNotifications" filterable class="w-100" :loading="_.isEmpty(applicationStages)" v-model="notification.stage" placeholder="">
							<el-option
								v-for="applicationStage in applicationStages"
								:key="applicationStage.id"
								:label="applicationStage.name"
								:value="applicationStage.id"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item
                        :prop="`notifications.${key}.action`"
                        :rules="{required: true, message: 'Required', trigger: 'change'}"
                        label="Action Trigger">
						<el-select :disabled="savingNotifications" filterable class="w-100" :loading="_.isEmpty(referrerActions)" v-model="notification.action" placeholder="">
							<el-option v-for="item in referrerActions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
                <el-col :span="4">
                    <el-form-item label="Remove" label-position="top">
                        <el-button :disabled="savingNotifications" @click="removeNotification(key)" class="w-100" icon="fas fa-trash" type="danger"></el-button>
                    </el-form-item>
                </el-col>
			</el-row>

            <el-row class="mb-2" :gutter="10">
                <el-col :span="6">
                    <el-button :disabled="savingNotifications" @click="addNotification()" class="w-100" icon="fas fa-plus" type="success">  Add Notification</el-button>
                </el-col>
                <el-col :span="6">
                    <el-button :disabled="savingNotifications" @click="saveNotifications()" class="w-100" icon="fas fa-save" type="primary">  {{saveText}}</el-button>
                </el-col>
            </el-row>

		</el-form>
	</div>
</template>

<script>
	export default {
		name: "ReferrerStageNotifications",

		data() {
			return {
                notificationForm: {
                    notifications: []
                },
                savingNotifications: false,
                fetchingNotifications: false,
                saveText: "Save Notifications",
				notifyReferrerActions: [],
				applicationStages: [],
			}
		},

		computed: {
			referrerActions() {
				if (_.isEmpty(this.notifyReferrerActions)) return []
				return this.notifyReferrerActions.map((action) => {

                    let label = action.name ? action.name : "Email: " + _.get(action, "tenant_email_template.name", _.get(action, "admin_email_template.name", "N/A")) + " Sms: " + _.get(action, "tenant_sms_template.name", _.get(action, "admin_sms_template.name", "N/A"))

					return {
						value: _.get(action, "uid"),
						label: label
					}
				})
			},
		},

		mounted() {
            this.getNotifications()
			this.getNotifyReferrerActions()
			this.getApplicationStages()
		},

		methods: {
            getNotifications() {
                this.fetchingNotifications = true
                axios
					.post("/api/referrer-notification/get-notifications")
					.then((res) => {
						this.notificationForm.notifications = res.data.map(notification => {
                            return {
                                id: notification.id,
                                action: notification.action_uid,
                                stage: notification.application_status_id
                            }
                        })
					})
					.catch((err) => {
						console.error(err)
					})
                    .finally(() => {
                        this.fetchingNotifications = false
                    })
            },
			getNotifyReferrerActions() {
				axios
					.post("/api/referrer-notification/get-notify-referrer-actions")
					.then((res) => {
						this.notifyReferrerActions = res.data
					})
					.catch((err) => {
						console.error(err)
					})
			},
			getApplicationStages() {
				axios
					.post("/api/referrer-notification/get-application-stages")
					.then((res) => {
						this.applicationStages = res.data
					})
					.catch((err) => {
						console.error(err)
					})
			},
            addNotification() {
                this.notificationForm.notifications.push({
                    stage: "",
					action: "",
                })
				setTimeout(() => {
                    this.$refs.notificationForm.clearValidate()
                }, 1)
            },
            removeNotification(key) {
                swal({
					title: "Remove Notification",
					text: `Are you sure you want to remove this notification`,
					type: "warning",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					cancelButtonColor: "#d33",
					confirmButtonText: "Remove",
					confirmButtonColor: "#284da5",
					reverseButtons: false,
				}).then((actioned) => {
					if (actioned.value) {
						Vue.delete(this.notificationForm.notifications, key)
					}
				})
            },
            saveNotifications() {
                this.$refs.notificationForm.validate((valid) => {
					if (valid) {
                        this.savingNotifications = true,
                        this.saveText = "Saving..."
                        axios
                            .post("/api/referrer-notification/save-notifications", this.notificationForm)
                            .then((res) => {
                                this.$notify({
									title: "Saved!",
									message: "You have saved your notifications.",
								})
                            })
                            .catch((err) => {
                                this.$notify({
									title: "Error!",
									message: "There was an error saving your notifications.",
								})
                                console.error(err)
                            })
                            .finally(() => {
                                this.savingNotifications = false
                                this.saveText = 'Save Notifications'
                            })
                    }
                })
            }
		},
	}
</script>

<style lang="scss" scoped>
</style>
